// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { INVOICE_HUB_TABLES, INVOICE_HUB_AUTOMATION_IDS } from '../../consts/consts';
import { invoiceIcon } from '../../../../../assets/svg';
import Icon from '../../../../../generic-components/Icon';

interface ITableEmptyState {
  name: string;
}

const EmptyStateTitleResources = {
  [INVOICE_HUB_TABLES.OUTSTANDING.name]: 'INVOICE_HUB.EMPTY_STATE.TITLE.OUTSTANDING',
  [INVOICE_HUB_TABLES.PAID.name]: 'INVOICE_HUB.EMPTY_STATE.TITLE.PAID',
  [INVOICE_HUB_TABLES.CANCELED.name]: 'INVOICE_HUB.EMPTY_STATE.TITLE.CANCELED',
};

const EmptyStateSubTitleResources = {
  [INVOICE_HUB_TABLES.OUTSTANDING.name]: 'INVOICE_HUB.EMPTY_STATE.SUBTITLE.OUTSTANDING',
  [INVOICE_HUB_TABLES.PAID.name]: 'INVOICE_HUB.EMPTY_STATE.SUBTITLE.PAID',
};

const TestIdByTableName = {
  [INVOICE_HUB_TABLES.OUTSTANDING.name]: INVOICE_HUB_AUTOMATION_IDS.HUB_TABLE_EMPTY_STATE_OUTSTANDING,
  [INVOICE_HUB_TABLES.PAID.name]: INVOICE_HUB_AUTOMATION_IDS.HUB_TABLE_EMPTY_STATE_PAID,
  [INVOICE_HUB_TABLES.CANCELED.name]: INVOICE_HUB_AUTOMATION_IDS.HUB_TABLE_EMPTY_STATE_CANCELED,
};

const getMainTitleByTableName = (name: string) => EmptyStateTitleResources[name] || '';
const getSubTitleByTableName = (name: string) => EmptyStateSubTitleResources[name] || '';

const AUTOMATION_IDS_PREFIX = {
  [INVOICE_HUB_TABLES.OUTSTANDING.name]: 'unpaid',
  [INVOICE_HUB_TABLES.PAID.name]: 'historyPaid',
  [INVOICE_HUB_TABLES.CANCELED.name]: 'historyCanceled',
};

export const TableEmptyState = ({ name }: ITableEmptyState) => {
  const { t } = useTranslation();
  const title = getMainTitleByTableName(name);
  const subtitle = getSubTitleByTableName(name);
  return (
    <div
      className='w-full h-[356px] border-l border-r border-b rounded-b-lg border-bw03 flex bg-bw00'
      data-testid={TestIdByTableName[name]}
    >
      <div className='flex justify-center items-center self-center flex-wrap grow'>
        <Icon className='w-[76px] h=[76px]' src={invoiceIcon} />
        {title && (
          <div
            data-testid={`${AUTOMATION_IDS_PREFIX[name]}EmptyStateMsgTitle`}
            className='w-full text-center text-bw08 font-metricR mt-[10px] mb-[4px] text-[24px]'
          >
            {t(title)}
          </div>
        )}
        {subtitle && (
          <div
            data-testid={`${AUTOMATION_IDS_PREFIX[name]}EmptyStateMsgText`}
            className='w-full text-center text-bw07 max-w-[480px] font-metricR text-sm'
          >
            {t(subtitle)}
          </div>
        )}
      </div>
    </div>
  );
};
